import lodash from "lodash";

export function filterMap<A, B>(
  array: A[],
  func: (a: A) => B | null | undefined
): B[] {
  return lodash.flatMap(array, item => {
    const ans = func(item);
    return ans == null ? [] : [ans];
  });
}
